export default "__VITE_ASSET__DRd6bRxV__"